import { NextRequest, NextResponse } from 'next/server';
import { db } from '@/lib/db';

export async function GET(request: NextRequest) {
  try {
    const { searchParams } = new URL(request.url);
    const email = searchParams.get('email');

    if (!email) {
      return NextResponse.json(
        { error: 'Email is required' },
        { status: 400 }
      );
    }

    const gyms = await db.gyms.findByOwnerEmail(email);

    if (gyms.length === 0) {
      return NextResponse.json(
        { gym: null },
        { status: 200 }
      );
    }

    return NextResponse.json({
      success: true,
      gym: gyms[0], // Return first gym profile
    });
  } catch (error) {
    console.error('Error fetching gym profile:', error);
    return NextResponse.json(
      { error: 'Failed to fetch gym profile' },
      { status: 500 }
    );
  }
}
